const integrations = {
  metadata: {
    required: "Fill in the required fields before connecting this tool.",
    tab: "Metadata",
    valuePlaceholder: "value",
  },
  models: {
    problem: {
      emptyName: "There is a model without a name.",
      duplicate: "{{model}}: duplicate name.",
      missingApi: "{{model}}: choose the route.",
      missingDimensions: "{{model}}: enter the dimensions (vector size).",
      invalidDimensions: "{{model}}: dimensions must be a positive whole number.",
    },
    empty: "No models registered.",
    add: "Add model",
    remove: "Remove model",
    namePlaceholder: "model or deployment name",
    apiPlaceholder: "route",
    apiVersionPlaceholder: "api-version",
    apiVersionSuspect:
      "This value does not look like the date format providers use for api-version. Double-check it before saving.",
    apiVersionHint:
      "The api-version is the provider's REST API version, not the model version shown in its portal. It applies to this model only: different routes on the same resource may require different versions.",
    dimensionsPlaceholder: "dimensions",
    serves: "serves the model {{model}}",
    invalid: "Review the models: each one needs a name and a route, and indexing models need the dimensions.",
  },
  title: "Tools",
  description: "Integrate all your tools in one place",
  kind: {
    mcp: "MCP Server",
    api: "API Connector"
  },
  review: {
    pending: "Pending review"
  },
  mcp: {
    serverUrl: "Server URL",
    authMode: "Authentication",
    authModes: {
      none: "None",
      bearer: "Bearer token",
      apikey: "API key",
      oauth: "OAuth"
    },
    authHeader: "Header name",
    apiKey: "API key",
    token: "Token",
    toolsSyncedAt: "Tools synced on {{date}}",
    noAuthHint: "This server does not require authentication.",
    add: {
      title: "Add MCP server",
      urlStep: "Enter the URL of the remote MCP server.",
      detailsStep: "Name this installation and choose where it is available.",
      inspect: "Inspect",
      connecting: "Connecting to the server to see how it authenticates and which tools it offers…",
      connectFailed: "Couldn't reach the server.",
      retry: "Try again",
      urlHint: "Prodgy connects to the server to find out how it authenticates and which tools it offers. Nothing is saved yet.",
      invalidUrl: "Enter a valid http(s) URL.",
      oauthStartFailed: "The tool was created, but the authorization did not start. Click Reconnect on the Connection tab.",
      alreadyInCatalog: "This server is already in the catalog as {{name}}. You will install that template.",
      oauthHint: "This server uses OAuth. After you confirm, you will be redirected to the provider to authorize access.",
      previewTools: "Preview tools",
      toolsAfterOauth: "The tools will be listed after you authorize access.",
      connectOauth: "Connect and authorize"
    }
  },
  oauth: {
    label: "OAuth",
    connected: "Server connected",
    connectedRefreshFailed: "Authorized, but the tool list did not come. Refresh the tools on the Tools tab.",
    failed: "Authorization failed",
    status: {
      pending: "Authorization pending",
      connected: "Connected",
      reconnect: "Reconnection needed"
    },
    connectedHint: "Access is authorized. Reconnect if you need to change the account or the permissions.",
    pendingHint: "Access is not authorized. Reconnect to authorize with the provider.",
    reconnect: "Reconnect"
  },
  connection: {
    keepCredential: "Leave blank to keep the current credential.",
    noFields: "This tool has no connection settings."
  },
  detail: {
    back: "Back to Tools",
    notFound: "We couldn't find this tool.",
    tabs: {
      general: "General",
      connection: "Connection",
      tools: "Tools",
      usage: "Usage"
    }
  },
  tools: {
    title: "Tools",
    count_one: "{{count}} tool",
    count_other: "{{count}} tools",
    empty: "No tools.",
    states: {
      enabled: "Active",
      confirm: "Asks for confirmation",
      blocked: "Blocked"
    },
    columns: {
      name: "Name",
      description: "Description",
      method: "Method",
      state: "State"
    },
    showSchema: "Show parameters",
    add: "Add tool",
    addTitle: "Add tool",
    editTitle: "Edit tool",
    dialogDescription: "The REST call the agents make when they use this tool.",
    endpoint: "Endpoint",
    inputSchema: "Parameters (JSON Schema)",
    inputSchemaHint: "A JSON Schema object describing the parameters the tool receives.",
    problems: {
      nameRequired: "Enter a name.",
      nameInvalid: "Use only letters, numbers, underscore, dot and hyphen (up to 128 characters).",
      nameTaken: "There is already a tool with this name.",
      endpointRequired: "Enter the endpoint.",
      schemaInvalidJson: "This is not valid JSON.",
      schemaNotObject: "The schema must be a JSON object."
    },
    removeTitle: "Remove tool",
    removeConfirm: "Remove the tool {{name}} from this installation? Agents will stop seeing it.",
    removed: "Tool {{name}} removed",
    compareTemplate: "Compare with template",
    refreshFromServer: "Refresh from server",
    diff: {
      refreshTitle: "Refresh from server",
      refreshDescription: "What changed on the server since the last sync. Agents only see the changes after you accept them.",
      refreshSummary: "{{added}} new · {{changed}} changed · {{removed}} removed from the server",
      removedFromServer: "Removed from the server",
      affectedSkills_one: "{{count}} skill uses tools that will change or be removed:",
      affectedSkills_other: "{{count}} skills use tools that will change or be removed:",
      acceptRefresh: "Accept changes",
      templateTitle: "Compare with template",
      templateDescription: "Tools that differ between this installation and the template. Choose which ones to bring from the template; selecting one that only exists here removes it.",
      none: "No differences.",
      summary: "{{added}} new in the template · {{changed}} changed · {{removed}} only in this installation",
      added: "Added",
      removed: "Only in this installation",
      changed: "Changed",
      applySelected: "Apply selected",
      applied: "Tools updated",
      serverChanged: "The server changed its tools since the preview. Review the new changes before applying."
    }
  },
  usage: {
    empty: "No calls recorded yet.",
    byTool: "Calls per tool",
    window_one: "Based on the last call.",
    window_other: "Based on the last {{count}} calls.",
    recent: "Recent calls",
    columns: {
      tool: "Tool",
      when: "When",
      status: "Status"
    },
    status: {
      success: "Success",
      error: "Error"
    }
  },
  empty: {
    title: "No tools found",
    description: "Configure a new tool to get started"
  },
  new: {
    title: "New Tool",
    description: "Configure a new tool"
  },
  form: {
    name: "Name",
    description: "Description",
    type: "Type",
    status: "Status",
    authType: "Authentication Type",
    selectAuthType: "Select an authentication type",
    title: {
      label: "Tool Name",
      placeholder: "Ex: Jira for Mobile Squad",
      required: "Tool name is required",
      taken: "There is already a tool with this name in the organization. Choose another one.",
      hint: "The name identifies this installation and is unique in the organization."
    },
    errors: {
      requiredFields: "Required fields not filled: {{fields}}",
      create: "Error creating tool. Check the data and try again.",
      update: "Error updating tool. Check the data and try again.",
      unknown: "Unknown error"
    },
    defaultDescription: "Tool configured via Prodgy"
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    awaitingConnection: "Awaiting connection — click to connect",
    failed: "Failed",
    connected: "Connected",
    disconnected: "Disconnected",
    syncing: "Syncing",
    synced: "Synced",
    unknown: "Unknown"
  },
  fields: {
    apiKey: "API Key",
    model: "Model",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    accessToken: "Access Token",
    redirectUri: "Redirect URI",
    privateToken: "Private Token",
    gitlabUrl: "GitLab URL",
    gitlabProjectId: "GitLab Project ID",
    organization: "Organization",
    googleProjectId: "Google Project ID",
    username: "Username",
    password: "Password",
    scope: "Scope",
    apiKeyPlaceholder: "Enter your OpenRouter API key",
    modelPlaceholder: "Enter model name (e.g. openai/gpt-4)",
    clientIdPlaceholder: "Enter Client ID",
    clientSecretPlaceholder: "Enter Client Secret",
    accessTokenPlaceholder: "Enter Access Token",
    redirectUriPlaceholder: "Enter Redirect URI",
    privateTokenPlaceholder: "Enter Private Token",
    gitlabUrlPlaceholder: "Enter GitLab URL",
    gitlabProjectIdPlaceholder: "Enter GitLab Project ID",
    organizationPlaceholder: "Enter Organization name",
    googleProjectIdPlaceholder: "Enter Google Project ID",
    usernamePlaceholder: "Enter username",
    passwordPlaceholder: "Enter password",
    scopePlaceholder: "Enter scope"
  },
  actions: {
    connect: "Connect",
    disconnect: "Disconnect",
    save: "Save changes",
    cancel: "Cancel",
    test: "Test connection",
    sync: "Sync",
    update: "Update",
    connecting: "Connecting...",
    updating: "Updating...",
    remove: "Remove",
    configure: "Configure"
  },
  messages: {
    copyFailed: "Could not copy. Select the value and copy it manually.",
    connected: "Tool connected successfully",
    disconnected: "Tool disconnected successfully",
    saved: "Changes saved successfully",
    error: "Error processing operation",
    authUpdated: "Authentication settings updated successfully",
    authUpdateError: "Failed to update authentication settings",
    connectionTestFailed: "Connection test failed. Please check your credentials and try again.",
    cannotDelete: "Cannot remove tool",
    deleteSuccess: "was removed successfully!",
    deleteError: "Error removing tool. Please try again.",
    hasDependencies: "This tool is being used by {{dependencies}}. Remove these dependencies before deleting the tool."
  },
  searchPlaceholder: "Search tools...",
  searchTools: "Search tools...",
  addIntegration: "Add Tool",
  add: "Add",
  encrypted: "Encrypted",
  configure: "Configure",
  lastValidated: "Last validated",
  selectTemplate: "Select the tool you want to integrate with Prodgy",
  select: "Select",
  sections: {
    settings: "Settings",
    authentication: "Authentication"
  },
  placeholders: {
    select: "Select...",
    enterField: "Enter {{field}}"
  },
  defaultFields: {
    integrationName: "Tool Name",
    integrationNamePlaceholder: "Enter a name for this tool",
    apiKeyToken: "API Key/Token"
  },
  editDialog: {
    edit: "Edit",
    editTitle: "Edit {{name}}",
    updateSettings: "Update the tool settings and credentials",
    configureIntegration: "Configure the tool"
  },
  scope: {
    label: "Scope",
    addTo: "Add the tool to...",
    workspaceOnly: "Workspace only",
    globalAll: "Whole organization",
    sectionWorkspace: "From the workspace",
    sectionOrganization: "From the whole organization",
    missingOrg: "Could not identify the current organization.",
    missingWorkspace: "Select a workspace or mark the tool as global.",
    permissionsLabel: "Permissions",
    productLabel: "Product",
    organizationLabel: "Organization",
    organizationHint: "This tool will be available for use in all products of the organization.",
    productHint: "This tool will be available only in the current workspace, alongside the organization's tools.",
    product: "This product",
    general: "Global"
  },
  postInstall: {
    title: "Tool created — next steps",
    subtitle: "Configure {{name}} using the values below and follow the instructions to complete installation.",
    copied: "URL copied",
    copyFailed: "Failed to copy",
    copy: "Copy",
    instructionsLabel: "Setup instructions",
    confirm: "Got it",
    manifestLabel: "App Manifest",
    copyManifest: "Copy JSON",
    downloadZip: "Download ZIP",
    zipBuilding: "Building...",
    zipFailed: "Failed to build the ZIP package"
  },
  delete: {
    title: "Remove Tool",
    confirmMessage: "Are you sure you want to remove the tool <strong>{{name}}</strong>?",
    warning: "This action cannot be undone. All settings and credentials will be permanently lost.",
    removing: "Removing...",
    confirm: "Yes, Remove"
  },
  selector: {
    kindFilter: "Tool type",
    kinds: {
      mcp: "MCP Servers",
      api: "API Connectors"
    },
    noMcpServers: "No MCP servers found",
    noMcpServersHint: "Add a remote MCP server by its URL.",
    notFound: "Didn't find it?",
    addMcpServer: "Add MCP server",
    noIntegrations: "No tools",
    noToolsFound: "No tools found",
    resultCount_one: "{{count}} tool",
    resultCount_other: "{{count}} tools",
    filtered_one: "filtered",
    filtered_other: "filtered",
    forQuery: "for \"{{query}}\"",
    requiredNotInstalled: "The tool required by the flow is not installed",
    addNewPrompt: "Or add a new tool...",
    addFirstPrompt: "Add a tool to get started...",
    templateDescription: "Tool template"
  }
} as const;

export default integrations;
